import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Link } from 'react-router';

export default class HorseSummaryElement extends PureComponent {
  static propTypes = {
    label: PropTypes.string,
    link: PropTypes.string,
    children: PropTypes.node
  }

  render() {
    const {
      label,
      link,
      children
    } = this.props;

    return (
      <li>
        <span className="horse-profile-summary-label">{label}</span>
        {link ?
          <Link className="horse-profile-summary-value" to={link}>{children}</Link>
          : <span className="horse-profile-summary-value">{children}</span>
        }
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/Profiles/HorseSummaryElement.js